"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Service = function Service(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M19.493 11.968c0-.653-.125-3.794-2.208-5.951C16.006 4.685 14.251 4.016 12.061 4h-.072c-6.793 0-7.459 6.53-7.525 7.821a1.05 1.05 0 00-.464.874v1.7c0 .588.477 1.065 1.066 1.065h.471a.757.757 0 001.465-.266v-3.447a.76.76 0 00-1.217-.602c.357-1.9 1.649-5.952 6.164-5.952h.03c4.653.022 5.86 4.263 6.177 6.096a.76.76 0 00-1.366.458v3.442a.76.76 0 001.025.708c-.162.677-.62 1.023-1.497 1.561-.8.493-2.248.775-2.949.887a2.049 2.049 0 00-1.297-.402c-.914 0-1.63.456-1.63 1.034 0 .578.71 1.028 1.624 1.028a1.923 1.923 0 001.423-.533 17.348 17.348 0 003.237-.932 3.527 3.527 0 002.36-3.154c.416-.153.694-.548.698-.991v-1.7c0-.27-.103-.531-.29-.727z"
  }));
};

var _default = (0, _react.forwardRef)(Service);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Service, "Service", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Service.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Service.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();